module.exports = __webpack_public_path__ + "static/media/corporate-services-img44.5ad20293.jpg";